import { DS as DSModule } from '../../CIMSModule/instances'
import { CIMSPage } from '../../cimsPage'
import { Permission } from '../../permission'
import { RoleTemplateItem } from '../RoleTemplateItem'

const DS = 'Design Submittal'
const DSWF = `${DS}s workflow`

export const DSAdmin = new RoleTemplateItem({
  id: '74e0b515-3eda-4b71-a080-625a4de03c7b',
  name: `${DS} Admin`,
  description: `Gives users access to all permissions within the ${DSWF}`,
  module: DSModule,
  permissionItems: Permission.findByModule(DSModule),
})

export const DSRouter = new RoleTemplateItem({
  id: 'ea2713c3-4ee0-46aa-884f-28dd6d08c8f9',
  name: `${DS} Router`,
  description: `Allows users to Route submitted submittals to the corresponding groups for review in the ${DSWF}`,
  module: DSModule,
  permissionItems: [
    Permission.ViewDesignSubmittal,
    Permission.ViewDesignSubmittalOrganization,
    Permission.ViewDesignSubmittalQuickLink,
    Permission.CreateDesignSubmittal,
    Permission.RouteDesignSubmittal,
    Permission.CommentOnDesignSubmittal,
    Permission.EditNumberNameDesignSubmittal,
    Permission.EditDesignSubmittal,
    Permission.GiveDispositionDesignSubmittal,
    Permission.RemoveRestoreDesignSubmittal,
    Permission.RevertDesignSubmittal,
    Permission.CreateDesignSubmittalType,
    Permission.EditDesignSubmittalType,
    Permission.RemoveRestoreDesignSubmittalType,
    ...Permission.findByPage(CIMSPage.DSOrganizations),
    Permission.CreateDesignSubmittalDiscipline,
    Permission.EditDesignSubmittalDiscipline,
    Permission.RemoveRestoreDesignSubmittalDiscipline,
    Permission.CreateDesignSubmittalAction,
    Permission.EditDesignSubmittalAction,
    Permission.RemoveRestoreDesignSubmittalAction,
    ...Permission.findByPage(CIMSPage.DSQuickLinks),
  ],
})

export const DSGroupReviewer = new RoleTemplateItem({
  id: 'b4981179-a7ef-4dd3-8f1f-389b6a572a59',
  name: 'Design Group Reviewer',
  description: `Allows users to Approve or Reject submittals for their assigned group when in group review status in the ${DSWF}`,
  module: DSModule,
  permissionItems: [
    Permission.ViewDesignSubmittal,
    Permission.CreateDesignSubmittal,
    Permission.CommentOnDesignSubmittal,
    Permission.ViewDesignSubmittalOrganization,
    Permission.ViewDesignSubmittalQuickLink,
  ],
})

export const DSContractor = new RoleTemplateItem({
  id: '2ad01be8-edd9-4bb1-8684-41bb731ccee4',
  name: 'Design Contractor',
  description: `Allows users to Create, Comment on, and View ${DS}s`,
  module: DSModule,
  permissionItems: [
    Permission.ViewDesignSubmittal,
    Permission.CreateDesignSubmittal,
    Permission.CommentOnDesignSubmittal,
    Permission.ViewDesignSubmittalOrganization,
    Permission.ViewDesignSubmittalQuickLink,
  ],
})

export const DSCloser = new RoleTemplateItem({
  id: '7601775a-c82a-49d3-baa5-4f6c09a4810e',
  name: `${DS} Closer`,
  description: `Allows users to Close submittals in the ${DSWF}`,
  module: DSModule,
  permissionItems: [
    Permission.ViewDesignSubmittal,
    Permission.CreateDesignSubmittal,
    Permission.ReviewAllDesignSubmittal,
    Permission.CommentOnDesignSubmittal,
    Permission.GiveDispositionDesignSubmittal,
    Permission.RemoveRestoreDesignSubmittal,
    Permission.RevertDesignSubmittal,
    Permission.ViewDesignSubmittalOrganization,
    Permission.ViewDesignSubmittalQuickLink,
  ],
})

export type DSRoleTemplateItem =
  | typeof DSAdmin
  | typeof DSRouter
  | typeof DSGroupReviewer
  | typeof DSContractor
  | typeof DSCloser
